import { ValueOf } from './util';

export const ETargetSelection = {
  ALL: 'すべて',
  COMPANY_OR_SHOP: '企業・店舗選択',
  CSV_UPLOAD: 'CSV一括アップロード',
  NONE: 'なし',
} as const;

export type TargetSelectionKey = keyof typeof ETargetSelection;
export type TargetSelectionValue = ValueOf<typeof ETargetSelection>;

export const targetSelectionKeys = Object.keys(ETargetSelection) as (TargetSelectionKey[]);

/** v-select用items */
export const targetSelectionItems = targetSelectionKeys
  .filter((key) => key !== 'NONE')
  .map((key) => ({
    title: ETargetSelection[key],
    value: key,
  }));
